<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales ",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
          active: true,
        },
      ],

      awesome: true,
      lista: [],
      file: null,
      loading: true,

      item: null,
      submitted: false,

      itemData: null,

      accident: {
        accident_report_types_id: null,
        report_subtypes_id: null,
        accident_agents_id: null,
        injured_part_bodies_id: null,
        type_of_injuries_id: null,
        event_types_id: null,
        report_date: null,
        hour: null,
        description: null,
        improvement_plan: null,
        arl_report_date: null,
        file: "",
        employee_id: null,
        site: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],
    };
  },
  methods: {

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(32)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getSubType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident
          this.subtype = typeAccident[0].report_subtype
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTypeEvent() {
      accidentAPI.getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI.gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI.getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI.getInjuredPartBody()
        .then((response) => {
          this.parteAfectada = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 32)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
   * This method is used to send notification to SST user and SST company.
   * The sendNotification method import is required.
   * @param {Number} messageID - The message ID that will be associated to notification.
   * @param {Number} itemID - The item ID that will be associated to notification.
   */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"]
      return sendNotification(company.id, company.id_diseno_sso, messageID, itemID)
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getAccident() {
      accidentAPI
        .getAccident(this.$route.params.id)
        .then((response) => {
          this.accident = {
            accident_report_types_id: response.accident_report_types_id,
            report_subtypes_id: response.accident_report_types_id,
            accident_agents_id: response.accident_agents_id,
            injured_part_bodies_id: response.injured_part_bodies_id,
            type_of_injuries_id: response.type_of_injuries_id,
            event_types_id: response.event_types_id,
            report_date: response.report_date,
            hour: response.hour,
            description: response.description,
            improvement_plan: response.improvement_plan,
            arl_report_date: response.arl_report_date,
            file: response.file,
            employee_id: response.employee_id,
            site: response.site,
            companies_id: response.companies_id,
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    update() {
      this.submitted = true;
      this.loading = true;
      accidentAPI
        .updateAccident(this.$route.params.id, {
          accident_report_types_id: this.accident.accident_report_types_id,
          report_subtypes_id: this.accident.report_subtypes_id,
          accident_agents_id: this.accident.accident_agents_id,
          injured_part_bodies_id: this.accident.injured_part_bodies_id,
          type_of_injuries_id: this.accident.type_of_injuries_id,
          event_types_id: this.accident.event_types_id,
          report_date: this.accident.report_date,
          hour: this.accident.hour,
          description: this.accident.description,
          improvement_plan: this.accident.improvement_plan,
          arl_report_date: this.accident.arl_report_date,
          file: this.accident.file,
          site: this.accident.site,
          employee_id: this.accident.employee_id,
          companies_id: this.accident.companies_id,
          company_classification_id: this.accident.company_classification_id,
          items_id: this.accident.items_id,
        })
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 32,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Accidente actualizado conm éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              }, 2000)
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        });
    },

  },

  mounted() {
    this.getAccident()
    this.getUsers();
    this.getItems()
    this.getItemData();
    this.getSubType()
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Descargar el archivo con la matriz de IPEVR, realizar diligenciamiento de cada uno de los campos
                      correspondientes, para poder determinar los controles que se deberán implementar. Es necesario que
                      se cuente con la participación de todos los niveles de la organización en la identificación de
                      estos peligros, se puede realizar por medio de capacitaciones, encuestas, inspecciones, entre
                      otros.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                  <a href="/forms/accidentes" id="tooltip">
                    Documentación accidentes y enfermedades laborales
                  </a>

                  <b-tooltip target="tooltip" placement="left">
                    Ir a Formato único de reporte de presunto accidente de trabajo (FURAT)
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>
                <br>
                <br>
              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6" label="Empleado" label-for="employee">
                    <select id="employee_id" class="form-control" v-model="accident.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label="Tipo" label-for="tipo" inline class="col-sm-4 pl-4">
                    <label class="mr-2">
                      Accidente
                    </label>
                    <input type="radio" style="color: #666" :value="1" v-model="accident.accident_report_types_id"
                      class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                    <label class="mr-2 pl-sm-2 pl-md-0">
                      Incidente
                    </label>
                    <input type="radio" :value="2" v-model="accident.accident_report_types_id"
                      class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                    <label class="mr-2 pl-sm-2 pl-md-0">
                      Enfermedad laboral
                    </label>
                    <input type="radio" :value="3" v-model="accident.accident_report_types_id"
                      class="mb-2 mr-sm-2 mb-sm-0" label="enfermedad" />
                  </b-form-group>
                </div>

                <div class="form-row mt-2 ml-4">

                  <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                    class="col-sm-2 mr-4" label="Tipo de accidente">

                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="accident.report_subtypes_id">
                      <b-form-select-option v-for="tipo1 in subtype" :key="tipo1.id" :value="tipo1.id">
                        {{ tipo1.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                    class="col-sm-2 mr-4" label="Tipo de evento">

                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="accident.event_types_id">
                      <b-form-select-option v-for="tipo2 in typeEvent" :key="tipo2.id" :value="tipo2.id">
                        {{ tipo2.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                    class="col-sm-2 mr-4" label="Tipo de lesión">

                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="accident.type_of_injuries_id">
                      <b-form-select-option v-for="tipo3 in lesion" :key="tipo3.id" :value="tipo3.id">
                        {{ tipo3.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                    class="col-sm-2 mr-4" label="Agente del accidente">

                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="accident.accident_agents_id">
                      <b-form-select-option v-for="tipo4 in agente" :key="tipo4.id" :value="tipo4.id">
                        {{ tipo4.name }}
                      </b-form-select-option>
                    </select>

                  </b-form-group>
                  <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                    class="col-sm-2 mr-4" label="Parte del cuerpo afectada">

                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="accident.injured_part_bodies_id">
                      <b-form-select-option v-for="tipo5 in parteAfectada" :key="tipo5.id" :value="tipo5.id">
                        {{ tipo5.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group v-else id="report_type" label-for="type" class="col-sm-2">

                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                    <b-form-input v-model="accident.report_date" type="date" id="input-sm"
                      placeholder="fecha"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6" label="Hora" label-for="hora">
                    <b-form-input v-model="accident.hour" type="time" id="hora"></b-form-input>
                  </b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-12" label="Lugar" label-for="input-sm">
                    <b-form-input type="text" maxlength="100" :disabled="!getRole('Crear') || !allowAccess()"
                      id="textarea" v-model="accident.site" rows="4"></b-form-input>

                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Descripción de la situación" label-for="input-sm">
                    <b-form-textarea id="textarea" v-model="accident.description" rows="4"></b-form-textarea>
                  </b-form-group>

                </div>
                <div class="form-row">
                  <b-form-group class="col-md-12" label="Plan de mejora" label-for="input-sm">
                    <b-form-textarea id="textarea" v-model="accident.improvement_plan" rows="4"></b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" class="btn btn-primary" :disabled="submitted">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>